<template lang="pug">
  div.detail-panel(v-if="currentDetailNode")
    div.detail-content
      p.mb-1.line-height-1 PV: {{ currentDetailNode.pv_count }}
      p.mb-1.line-height-1(v-if="selectedPoint === 'start'") FV離脱率: {{ Number(currentDetailNode.fv_exit_percent).toFixed(1) }}%
      p.mb-1.line-height-1 平均滞在時間: {{ currentDetailNode.avg_stay_time }}秒
      hr.custom-divider
      p.mb-1.line-height-1
        a(
          :href="currentDetailNode.heatmap_ids && currentDetailNode.heatmap_ids.length > 0 ? `/users/heatmaps?ids=${currentDetailNode.heatmap_ids.join(',')}` : '#'"
          :class="{ 'disabled-link': !currentDetailNode.heatmap_ids || currentDetailNode.heatmap_ids.length === 0 }"
        ) ヒートマップ
      p.mb-1.line-height-1
        a(
          :href="hasAnyPopupIds ? generatePopupUrl() : '#'"
          :class="{ 'disabled-link': !hasAnyPopupIds }"
        ) ポップアップ
      hr.custom-divider
      p.mb-1.line-height-1
        a.link-style(@click="$emit('setStartPoint')") 始点にする
      p.mb-1.line-height-1
        a.link-style(@click="$emit('setEndPoint')") 終点にする
</template>

<script>
export default {
  name: 'user_flow_detail_panel',
  props: {
    currentDetailNode: {
      type: Object,
      default: null
    },
    selectedPoint: {
      type: String,
      required: true
    }
  },
  computed: {
    hasAnyPopupIds() {
      return (
        this.currentDetailNode &&
        (this.currentDetailNode.pop_up_ids && this.currentDetailNode.pop_up_ids.length > 0) ||
        (this.currentDetailNode.area_pop_up_ids && this.currentDetailNode.area_pop_up_ids.length > 0) ||
        (this.currentDetailNode.overlay_ids && this.currentDetailNode.overlay_ids.length > 0) ||
        (this.currentDetailNode.scenario_popup_ids && this.currentDetailNode.scenario_popup_ids.length > 0)
      );
    }
  },
  methods: {
    generatePopupUrl() {
      const params = new URLSearchParams();

      const addArrayParams = (key, values) => {
        if (Array.isArray(values) && values.length > 0) {
          // 配列をカンマ区切りの文字列に変換
          params.append(key, values.join(','));
        }
      };

      addArrayParams('pop_up_ids', this.currentDetailNode.pop_up_ids);
      addArrayParams('area_pop_up_ids', this.currentDetailNode.area_pop_up_ids);
      addArrayParams('overlay_ids', this.currentDetailNode.overlay_ids);
      addArrayParams('scenario_popup_ids', this.currentDetailNode.scenario_popup_ids);

      return `/users/popups?${params.toString()}`;
    }
  }
};
</script>

<style scoped>
.detail-panel {
  position: absolute;
  top: 256px;
  left: 70px;
  background: #F4F6F9;
  padding: 8px;
  border-radius: 8px;
  border: 1px solid black;
  width: 240px;
  z-index: 999;
}

.line-height-1 {
  line-height: 1rem;
}

.custom-divider {
  border: none;
  border-top: 2px solid #000;
  margin: 8px 0;
}

a {
  color: #007bff;
  text-decoration: none;
  &:hover {
    text-decoration: underline;
  }

  &.disabled-link {
    color: #6c757d;
    cursor: not-allowed;
    pointer-events: none;
    text-decoration: none;
  }

  &.link-style {
    color: #007bff;
    cursor: pointer;
    text-decoration: none;
    &:hover {
      text-decoration: underline;
    }
  }
}
</style> 
